import { Suspense } from 'react';
import { Container } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { Loader } from 'shared/ui/loader';
import { MainFooter } from 'widgets/main-footer';
import { MainHeader } from 'widgets/main-header';
import styles from './app-layout.module.scss';

export const AppLayout = () => (
  <Container
    className={styles.appContainer}
    maxWidth={false}
    sx={{
      maxWidth: '1440px',
      minHeight: '100vh',
      '&': {
        paddingLeft: '20px',
        paddingRight: '20px',
      },
    }}
  >
    <MainHeader />
    <Suspense fallback={<Loader />}>
      <Outlet />
    </Suspense>
    <MainFooter />
  </Container>
);
